"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDrillToAttributeUrl = exports.isDrillToCustomUrl = exports.isDrillToInsight = exports.isDrillToDashboard = exports.isDrillToLegacyDashboard = exports.isDrillFromAttribute = exports.isDrillFromMeasure = exports.getAttributeIdentifiersPlaceholdersFromUrl = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
/* eslint-disable @typescript-eslint/no-empty-interface, import/namespace */
var m = tslib_1.__importStar(require("@gooddata/sdk-model"));
var drillUrls_1 = require("./drillUrls");
Object.defineProperty(exports, "getAttributeIdentifiersPlaceholdersFromUrl", { enumerable: true, get: function () { return drillUrls_1.getAttributeIdentifiersPlaceholdersFromUrl; } });
/**
 * Type-guard testing whether the provided object is an instance of {@link IDrillFromMeasure}.
 * @deprecated Use {@link @gooddata/sdk-model#isDrillFromMeasure}
 * @alpha
 */
exports.isDrillFromMeasure = m.isDrillFromMeasure;
/**
 * Type-guard testing whether the provided object is an instance of {@link IDrillFromAttribute}.
 * @deprecated Use {@link @gooddata/sdk-model#isDrillFromAttribute}
 * @alpha
 */
exports.isDrillFromAttribute = m.isDrillFromAttribute;
/**
 * Type-guard testing whether the provided object is an instance of {@link IDrillToLegacyDashboard}.
 * @deprecated Use {@link @gooddata/sdk-model#isDrillToLegacyDashboard}
 * @alpha
 */
exports.isDrillToLegacyDashboard = m.isDrillToLegacyDashboard;
/**
 * Type-guard testing whether the provided object is an instance of {@link IDrillToDashboard}.
 * @deprecated Use {@link @gooddata/sdk-model#isDrillToDashboard}
 * @alpha
 */
exports.isDrillToDashboard = m.isDrillToDashboard;
/**
 * Type-guard testing whether the provided object is an instance of {@link IDrillToInsight}.
 * @deprecated Use {@link @gooddata/sdk-model#isDrillToInsight}
 * @alpha
 */
exports.isDrillToInsight = m.isDrillToInsight;
/**
 * Type-guard testing whether the provided object is an instance of {@link IDrillToCustomUrl}.
 * @deprecated Use {@link @gooddata/sdk-model#isDrillToCustomUrl}
 * @alpha
 */
exports.isDrillToCustomUrl = m.isDrillToCustomUrl;
/**
 * Type-guard testing whether the provided object is an instance of {@link IDrillToAttributeUrl}.
 * @deprecated Use {@link @gooddata/sdk-model#isDrillToAttributeUrl}
 * @alpha
 */
exports.isDrillToAttributeUrl = m.isDrillToAttributeUrl;
//# sourceMappingURL=drills.js.map